import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  truco,
  trucoAccept,
  trucoRefuse,
  trucoRaise,
  updateFlipped,
} from "../../redux/actions/game";

import avatar1 from "../../assets/images/avatar/avatar1.webp";
import avatar2 from "../../assets/images/avatar/avatar2.webp";
import avatar3 from "../../assets/images/avatar/avatar3.webp";
import avatar4 from "../../assets/images/avatar/avatar4.webp";
import avatar5 from "../../assets/images/avatar/avatar5.webp";
import avatar6 from "../../assets/images/avatar/avatar6.webp";
import avatar7 from "../../assets/images/avatar/avatar7.webp";
import avatar8 from "../../assets/images/avatar/avatar8.webp";
import avatar9 from "../../assets/images/avatar/avatar9.webp";
import avatar10 from "../../assets/images/avatar/avatar10.webp";
import avatar11 from "../../assets/images/avatar/avatar11.webp";
import avatar12 from "../../assets/images/avatar/avatar12.webp";
import avatar13 from "../../assets/images/avatar/avatar13.webp";
import avatar14 from "../../assets/images/avatar/avatar14.webp";
import avatar15 from "../../assets/images/avatar/avatar15.webp";
import avatar16 from "../../assets/images/avatar/avatar16.webp";
import avatar17 from "../../assets/images/avatar/avatar17.webp";
import avatar18 from "../../assets/images/avatar/avatar18.webp";
import avatar19 from "../../assets/images/avatar/avatar19.webp";
import avatar20 from "../../assets/images/avatar/avatar20.webp";
import avatar21 from "../../assets/images/avatar/avatar21.webp";
import avatar22 from "../../assets/images/avatar/avatar22.webp";
import avatar23 from "../../assets/images/avatar/avatar23.webp";
import avatar24 from "../../assets/images/avatar/avatar24.webp";
// import avatar25 from "../../assets/images/avatar/avatar25.webp";
// import avatar26 from "../../assets/images/avatar/avatar26.webp";
// import avatar27 from "../../assets/images/avatar/avatar27.webp";
// import avatar28 from "../../assets/images/avatar/avatar28.webp";
// import avatar29 from "../../assets/images/avatar/avatar29.webp";
import star from "../../assets/images/sheriff-badge-xp.png";
import trucoMarreco from "../../assets/voices/truco.mp3";
import "./Scoreboard.scss";
import { hapticHeavy, hapticMedium, hapticError, hapticSuccess } from "../../utils/haptic";

function Scoreboard() {
  const game = useSelector((state) => state.game);
  const timer = useSelector((state) => state.game.timer);
  const timerTruco = useSelector((state) => state.game.timerTruco);

  const dispatch = useDispatch();

  const { flipped } = game;

  const {
    p1,
    p2,
    next_to_play_id,
    round_points,
    truco_challenge_running,
    truco_challenger_id,
    modality,
    manilha,
  } = game.state;

  const [avatarP1, setAvatarP1] = useState(null);
  const [avatarP2, setAvatarP2] = useState(null);

  // Vibra quando recebe truco do oponente
  useEffect(() => {
    if (truco_challenge_running && truco_challenger_id === p2.id) {
      hapticHeavy();
    }
  }, [truco_challenge_running, truco_challenger_id]);

  // Dar lock nos botões durante pedido de truco, para evitar requisições dobradas
  const [buttonsLocked, setButtonsLocked] = useState(false);

  useEffect(() => {
    const a1 = getRandomItem();
    let a2 = getRandomItem();
    while (a2 === a1) a2 = getRandomItem();
    setAvatarP1(a1);
    setAvatarP2(a2);
  }, []);

  const askTruco = new Audio(trucoMarreco);

  const avatarList = [
    avatar1,
    avatar2,
    avatar3,
    avatar4,
    avatar5,
    avatar6,
    avatar7,
    avatar8,
    avatar9,
    avatar10,
    avatar11,
    avatar12,
    avatar13,
    avatar14,
    avatar15,
    avatar16,
    avatar17,
    avatar18,
    avatar19,
    avatar20,
    avatar21,
    avatar22,
    avatar23,
    avatar24,
    // avatar25,
    // avatar26,
    // avatar27,
    // avatar28,
    // avatar29,
  ];

  function getRandomItem() {
    const randomIndex = Math.floor(Math.random() * avatarList.length);
    const item = avatarList[randomIndex];
    return item;
  }

  function trucoChallenge() {
    if (!buttonsLocked) {
      hapticHeavy();
      askTruco.play().catch(() => {});
      setButtonsLocked(true);
      dispatch(truco());
      setTimeout(() => {
        setButtonsLocked(false);
      }, 1000);
    }
  }

  function accept() {
    if (!buttonsLocked) {
      hapticSuccess();
      setButtonsLocked(true);
      dispatch(trucoAccept());
      setTimeout(() => {
        setButtonsLocked(false);
      }, 1000);
    }
  }

  function raise() {
    if (!buttonsLocked) {
      hapticHeavy();
      setButtonsLocked(true);
      dispatch(trucoRaise());
      setTimeout(() => {
        setButtonsLocked(false);
      }, 1000);
    }
  }

  function refuse() {
    if (!buttonsLocked) {
      hapticError();
      setButtonsLocked(true);
      dispatch(trucoRefuse());
      setTimeout(() => {
        setButtonsLocked(false);
      }, 1000);
    }
  }

  function timerGo() {
    // askForfeit.play();
    // dispatch(timerCount());
  }

  function myTurn() {
    return next_to_play_id === p1.id;
  }

  function pointsToString(points) {
    if (modality === "paulista") {
      if (p1.game_score === 11 || p2.game_score === 11) {
        return "Mão de Onze!";
      }

      switch (points) {
        case 1:
          return "Truco!";

        case 3:
          return "Seis!";

        case 4:
          return "Seis!";

        case 6:
          return "Nove!";

        case 9:
          return "Doze!";

        case 12:
          return "Doze pontos!";

        default:
          return "Erro";
      }
    } else {
      if (p1.game_score === 10 || p2.game_score === 10) {
        return "Mão de Dez!";
      }

      switch (points) {
        case 2:
          return "Truco!";

        case 4:
          return "Seis!";

        case 6:
          return "Dez!";

        case 10:
          return "Doze!";

        case 12:
          return "Doze pontos!";

        default:
          return "Erro";
      }
    }

  }

  function getMineiroRaisePoints(points) {
    switch (points) {
      case 2:
        return 4
      case 4:
        return 6
      case 6:
        return 10
      case 10:
        return 12
      default:
        return 0
    }
  }



  return (
    <span className="scoreboard">
      <img
        alt="minha-vez"
        className={`star ${myTurn() ? "you" : "opponent"}`}
        src={star}
      />
      {!!truco_challenge_running && truco_challenger_id === p2.id && (() => {
        const parsePlay = (s) => {
          if (!s) return null;
          return { value: s.slice(0, -1), suit: s.slice(-1) };
        };
        const lastPlay = (p) =>
          parsePlay(p.third_play) ||
          parsePlay(p.second_play) ||
          parsePlay(p.first_play);
        const cards = [lastPlay(p1), lastPlay(p2)].filter(Boolean);

        const isManoDeOnze =
          modality === "paulista" &&
          (p1.game_score === 11 || p2.game_score === 11);
        const isManoDeDez =
          modality === "mineiro" &&
          (p1.game_score === 10 || p2.game_score === 10);

        const showRaise =
          !isManoDeOnze &&
          !isManoDeDez &&
          ((modality === "paulista" && round_points < 9) ||
            (modality === "mineiro" && round_points < 10));

        const raiseLabel =
          modality === "paulista"
            ? pointsToString(round_points + 3)
            : pointsToString(getMineiroRaisePoints(round_points));

        return (
          <div className={`trucoMessage ${isManoDeOnze || isManoDeDez ? "trucoMessage--handDecision" : ""}`}>
            <div className="trucoMessage__panel">
              <header className="trucoMessage__header">
                <h2 className="trucoMessage__title">
                  {isManoDeOnze || isManoDeDez ? (
                    <span className="trucoMessage__title-gold">
                      {isManoDeOnze ? "Mão de onze" : "Mão de dez"}
                    </span>
                  ) : (
                    <>
                      <span className="trucoMessage__title-red">{p2.name}</span>{" "}
                      <span className="trucoMessage__title-gold">
                        pediu {pointsToString(round_points)}
                      </span>
                    </>
                  )}
                </h2>

                {manilha && (
                  <div className="trucoMessage__vira" aria-hidden="true">
                    <img
                      src={require("../../assets/images/carta.webp")}
                      alt=""
                      className="trucoMessage__vira-back"
                      draggable={false}
                    />
                    <div
                      className={`trucoMessage__card trucoMessage__vira-face trucoMessage__card--${manilha.suit}`}
                    >
                      <span className="trucoMessage__card-value">
                        {manilha.value}
                      </span>
                      <span className="trucoMessage__card-suit">
                        {manilha.suit}
                      </span>
                    </div>
                  </div>
                )}
              </header>

              {cards.length > 0 && !isManoDeOnze && !isManoDeDez && (
                <>
                  <p className="trucoMessage__subtitle">Cartas jogadas</p>
                  <div className="trucoMessage__cards">
                    {cards.map((c, i) => (
                      <div
                        key={i}
                        className={`trucoMessage__card trucoMessage__card--${c.suit}`}
                      >
                        <span className="trucoMessage__card-value">{c.value}</span>
                        <span className="trucoMessage__card-suit">{c.suit}</span>
                      </div>
                    ))}
                  </div>
                </>
              )}

              <div className="trucoMessage__buttons">
                <button
                  type="button"
                  className="trucoMessage__btn trucoMessage__btn--danger"
                  disabled={buttonsLocked}
                  onClick={refuse}
                >
                  Recusar
                </button>
                <button
                  type="button"
                  className="trucoMessage__btn trucoMessage__btn--success"
                  disabled={buttonsLocked}
                  onClick={accept}
                >
                  Aceitar
                </button>
                {showRaise && (
                  <button
                    type="button"
                    className="trucoMessage__btn trucoMessage__btn--gold"
                    disabled={buttonsLocked || round_points >= 12}
                    onClick={raise}
                  >
                    {raiseLabel}
                  </button>
                )}
              </div>

              {(isManoDeOnze || isManoDeDez) && p1.cards && (
                <>
                  <p className="trucoMessage__subtitle">Sua mão</p>
                  <div className="trucoMessage__cards trucoMessage__cards--hand">
                    {p1.cards
                      .filter((c) => !c.played)
                      .map((c, i) => (
                        <div
                          key={i}
                          className={`trucoMessage__card trucoMessage__card--${c.suit}`}
                        >
                          <span className="trucoMessage__card-value">{c.value}</span>
                          <span className="trucoMessage__card-suit">{c.suit}</span>
                        </div>
                      ))}
                  </div>
                </>
              )}
            </div>
          </div>
        );
      })()}
      {!!truco_challenge_running && truco_challenger_id === p1.id && (() => {
        const parsePlay = (s) => {
          if (!s) return null;
          return { value: s.slice(0, -1), suit: s.slice(-1) };
        };
        const lastPlay = (p) =>
          parsePlay(p.third_play) ||
          parsePlay(p.second_play) ||
          parsePlay(p.first_play);
        const cards = [lastPlay(p1), lastPlay(p2)].filter(Boolean);
        const isManoDeOnze = modality === "paulista" && (p1.game_score === 11 || p2.game_score === 11);
        const isManoDeDez = modality === "mineiro" && (p1.game_score === 10 || p2.game_score === 10);

        const label = pointsToString(round_points);

        return (
          <div className={`trucoBubble ${isManoDeOnze || isManoDeDez ? "trucoBubble--compact" : ""}`}>
            <h2 className="trucoBubble__title">
              {isManoDeOnze ? (
                <span className="trucoBubble__title-gold">Mão de Onze!</span>
              ) : isManoDeDez ? (
                <span className="trucoBubble__title-gold">Mão de Dez!</span>
              ) : (
                <>
                  <span className="trucoBubble__title-you">Você</span>{" "}
                  <span className="trucoBubble__title-gold">pediu {label}</span>
                </>
              )}
            </h2>

            {manilha && (
              <div className="trucoBubble__vira" aria-hidden="true">
                <img
                  src={require("../../assets/images/carta.webp")}
                  alt=""
                  className="trucoBubble__vira-back"
                  draggable={false}
                />
                <div
                  className={`trucoBubble__card trucoBubble__vira-face trucoBubble__card--${manilha.suit}`}
                >
                  <span className="trucoBubble__card-value">
                    {manilha.value}
                  </span>
                  <span className="trucoBubble__card-suit">
                    {manilha.suit}
                  </span>
                </div>
              </div>
            )}
            {cards.length > 0 && (
              <>
                <p className="trucoBubble__subtitle">Cartas jogadas</p>
                <div className="trucoBubble__cards">
                  {cards.map((c, i) => (
                    <div
                      key={i}
                      className={`trucoBubble__card trucoBubble__card--${c.suit}`}
                    >
                      <span className="trucoBubble__card-value">{c.value}</span>
                      <span className="trucoBubble__card-suit">{c.suit}</span>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        );
      })()}
      <div className="menu-aside">
        <div className="aside-panel">
          <div className="aside-panel__avatar">
            <img alt="avatar" src={avatarP1} />
          </div>

          <div className="aside-panel__card">
            <div className="aside-panel__timer">
              <button onClick={timerGo} className="aside-panel__timer-btn">
                {timerTruco || (truco_challenge_running === 1 && "--") || timer}
              </button>
            </div>

            <div className="aside-panel__scores">
              <div className="aside-panel__score-header">
                <span>Jogadores</span>
                <span>Rodada</span>
                <span>Pontos</span>
              </div>
              <div className="aside-panel__score-row">
                <span className="aside-panel__player-name">{p1.name}</span>
                <span className="aside-panel__rounds">
                  {[0, 1, 2].map((i) => (
                    <span
                      key={i}
                      className={`aside-panel__dot ${
                        i < p1.round_score ? "aside-panel__dot--win" : ""
                      }`}
                    />
                  ))}
                </span>
                <span className="aside-panel__points-pill">{p1.game_score}</span>
              </div>
              <div className="aside-panel__score-row">
                <span className="aside-panel__player-name">{p2.name}</span>
                <span className="aside-panel__rounds">
                  {[0, 1, 2].map((i) => (
                    <span
                      key={i}
                      className={`aside-panel__dot ${
                        i < p2.round_score ? "aside-panel__dot--win" : ""
                      }`}
                    />
                  ))}
                </span>
                <span className="aside-panel__points-pill aside-panel__points-pill--hot">
                  {p2.game_score}
                </span>
              </div>
            </div>
          </div>

        <div className="aside-panel__actions">
          {round_points < 12 && (
            <button
              className="aside-panel__action-btn aside-panel__action-btn--truco"
              onClick={trucoChallenge}
              disabled={!myTurn() || truco_challenge_running || truco_challenger_id === p1.id || buttonsLocked}
            >
              {pointsToString(round_points) || "Aguardando"}
            </button>
          )}
          <button
            className="aside-panel__action-btn aside-panel__action-btn--hide"
            onClick={() => dispatch(updateFlipped())}
            disabled={!myTurn() || truco_challenge_running}
          >
            {flipped ? "Mostrar" : "Esconder"}
          </button>
        </div>
        </div>
      </div>
      <header className="scoreboard-mobile-header">
        <div className="mh-brand">
          <img
            src={require("../../assets/images/logo-trucoxo.png")}
            alt="Truco XP"
          />
        </div>

        <div className="mh-score-bar">
          <div className="mh-player mh-player--left">
            <span className="mh-player-name">{p1.name}</span>
            <span className="mh-ranking">({p1.ranking_score})</span>
          </div>

          <div className="mh-rounds">
            {[0, 1, 2].map((i) => (
              <span
                key={i}
                className={`mh-dot ${i < p1.round_score ? "win" : ""}`}
              />
            ))}
          </div>

          <div className="mh-center">
            <span className={`mh-score ${myTurn() ? "mh-score--active" : ""}`}>
              {p1.game_score}
            </span>
            <span className="mh-vs">×</span>
            <span className={`mh-score ${!myTurn() ? "mh-score--active" : ""}`}>
              {p2.game_score}
            </span>
          </div>

          <div className="mh-rounds">
            {[0, 1, 2].map((i) => (
              <span
                key={i}
                className={`mh-dot ${i < p2.round_score ? "win" : ""}`}
              />
            ))}
          </div>

          <div className="mh-player mh-player--right">
            <span className="mh-player-name">{p2.name}</span>
            <span className="mh-ranking">({p2.ranking_score})</span>
          </div>
        </div>
      </header>
      <nav className="mobile-menu">
        <ul>
          <li className="mobile-menu__timer">
            {timerTruco || (truco_challenge_running === 1 && "--") || timer}
          </li>
          {myTurn() &&
            round_points < 12 &&
            !truco_challenge_running &&
            ((modality === "paulista" && (p1.game_score !== 11 && p2.game_score !== 11)) || (modality === "mineiro" && (p1.game_score !== 10 && p2.game_score !== 10))) &&
            truco_challenger_id !== p1.id && (
              <li className="mobile-menu__action mobile-menu__action--truco" onClick={trucoChallenge}>
                  {pointsToString(round_points) || "Aguardando"}
              </li>
            )}
          {myTurn() && !truco_challenge_running && (
            <li className="mobile-menu__action mobile-menu__action--hide" onClick={() => dispatch(updateFlipped())}>
              {flipped ? "Mostrar" : "Esconder"}
            </li>
          )}
        </ul>
      </nav>
    </span>
  );
}

export default Scoreboard;
